import React from 'react';
import {KeolisSpinner} from '../containers/common/commonExport';

const AuditTrail = (props) => (
    <tr>
        <td data-title="Type">{props.audit.adt_type}</td>
        <td data-title="Table">{props.audit.adt_tbl_name}</td>
        <td data-title="Filed">{props.audit.adt_tabl_clm_name}</td>
        <td data-title="Old Value" className="cell-ellipsis nameCell"><span title={props.audit.adt_old_value}>{props.audit.adt_old_value ? props.audit.adt_old_value : 'NULL'}</span></td>
        <td data-title="New Value" className="cell-ellipsis nameCell"><span title={props.audit.adt_new_value}>{props.audit.adt_new_value ? props.audit.adt_new_value : 'NULL'}</span></td>
        <td data-title="Updated Time">{props.audit.adt_created_tsp}</td>
    </tr>
);

export default AuditTrail;